import { GridColDef, GridInitialState } from "@mui/x-data-grid-premium";
import React from "react";
import {
  getDateValue,
  renderDateCell,
  renderExternalLinkCell,
  renderNumberCell,
  renderWrappedCell,
  serverFilterDateOperators,
  serverFilterStringOperators,
  topListedOperator,
} from "utils/dataGrid";
import GaneshDataGridServerProcessing from "../../DataGrid/GaneshDataGridServerProcessing";

const defaultGridState: GridInitialState = {
  filter: {
    filterModel: {
      items: [],
    },
  },
  sorting: { sortModel: [{ field: "brand_name", sort: "asc" }] },
  pagination: { paginationModel: { pageSize: 250, page: 0 } },
  pinnedColumns: { left: [] },
  columns: { columnVisibilityModel: {} },
  density: "standard",
};

const columns_def: GridColDef[] = [
  {
    field: "top_listed_classification",
    headerName: "Top Listed Classification",
    width: 300,
    filterable: true,
    filterOperators: topListedOperator,
    sortable: true,
  },
  {
    field: "brand_id",
    headerName: "Brand ID",
    width: 150,
    filterable: true,
    filterOperators: serverFilterStringOperators,
    sortable: true,
  },
  {
    field: "brand_name",
    headerName: "Brand Name",
    width: 200,
    filterable: true,
    filterOperators: serverFilterStringOperators,
    sortable: true,
  },
  {
    field: "chain_id",
    headerName: "Chain ID",
    width: 150,
    filterable: true,
    filterOperators: serverFilterStringOperators,
    sortable: true,
  },
  {
    field: "stock_ticker_id",
    headerName: "Stock Ticker ID",
    width: 150,
    filterable: true,
    filterOperators: serverFilterStringOperators,
    sortable: true,
  },
  {
    field: "wikipedia",
    headerName: "Wikipedia",
    width: 250,
    filterable: true,
    filterOperators: serverFilterStringOperators,
    sortable: true,
    renderCell: renderExternalLinkCell,
  },
  {
    field: "all_names",
    headerName: "All Names",
    width: 300,
    filterable: true,
    filterOperators: serverFilterStringOperators,
    sortable: false,
    renderCell: renderWrappedCell,
  },
  {
    field: "website_domains",
    headerName: "Website Domains",
    width: 300,
    filterable: true,
    filterOperators: serverFilterStringOperators,
    sortable: false,
    renderCell: renderWrappedCell,
  },
  {
    field: "website",
    headerName: "Website",
    width: 250,
    filterable: true,
    filterOperators: serverFilterStringOperators,
    sortable: false,
    renderCell: renderExternalLinkCell,
  },
  {
    field: "business_categories",
    headerName: "Business Categories",
    width: 300,
    filterable: true,
    filterOperators: serverFilterStringOperators,
    sortable: false,
    renderCell: renderWrappedCell,
  },
  {
    field: "child_business_categories",
    headerName: "Child Business Categories",
    width: 300,
    filterable: true,
    filterOperators: serverFilterStringOperators,
    sortable: false,
    renderCell: renderWrappedCell,
  },
  {
    field: "estimated_count",
    headerName: "Estimated Count",
    type: "number",
    width: 100,
    renderCell: renderNumberCell,
    filterable: false,
    sortable: false,
  },
  {
    field: "estimated_counts_by_country",
    headerName: "Estimated Counts by Country",
    width: 300,
    filterable: false,
    sortable: false,
    renderCell: renderWrappedCell,
  },
  {
    field: "ownership_parent_id",
    headerName: "Ownership Parent ID",
    type: "number",
    width: 200,
    filterable: false,
    sortable: false,
  },
  {
    field: "logo",
    headerName: "Logo URL",
    width: 300,
    filterable: false,
    sortable: false,
  },
  {
    field: "frozen_at",
    headerName: "Frozen At",
    type: "date",
    width: 200,
    valueGetter: getDateValue,
    renderCell: renderDateCell,
    filterable: true,
    filterOperators: serverFilterDateOperators,
  },
];

const BrandsMetadataTable: React.FC<any> = () => {
  return (
    <GaneshDataGridServerProcessing
      fetchApi="/brand_reports/brands_metadata_summary"
      columns={columns_def}
      gridId="brandsMetadataGrid"
      defaultGridState={defaultGridState}
    />
  );
};

export default BrandsMetadataTable;
